<template>
  <div class="solutionDebtInfo-warpper2" :style="solutionDebtInfoWarpperStyle">
    <nav-bar titleText="申请解债" titleWeight="bold" @goBack="goBack" :isFixed="true" ></nav-bar>
    <div class="divider"></div>
    <div class="content">
      <div class="comments">
        <p class="comment" v-for="(item, i) in comments.split('\n')" :key="i">
          {{ item }}
        </p>
      </div>
      <div class="input_money">
        <p class="marTop12 title marBottom7">请输入本金</p>
        <van-field
          v-model="value1"
          name="本金"
          label="¥"
          type="number"
          placeholder="请输入本金"
          @input="limitMoney1"
          :rules="[{ required: true, message: '请输入本金' }]"
        />
        <p class="title marTop11 marBottom7">请输入利息</p>
        <van-field
          v-model="value2"
          name="利息"
          label="¥"
          type="number"
          placeholder="请输入利息"
          @input="limitMoney2" 
          :rules="[{ required: true, message: '请输入利息' }]"
        />
      </div>

      <div class="title marTop11 marBottom3">
        <span class="color999">解债总金额 ¥{{solutionMoney}}&nbsp;|&nbsp;</span>
        <span class="color999">减免债务金额 ¥{{reduceDebt}}</span>
      </div>
      <div class="title marTop11 marBottom3">
        <span class="colorOrg">需偿还债务金额 ¥{{needMoney}}</span>
      </div>

      <div class="info van-clearfix">
        <div class="collect_details">
          <p class="color999 payment_account">请债务人本人将需偿还债务金额汇至下方万融收款账号（手机银行、网上银行、柜台均可）及债务情况证明材料，注意：打款不要备注。完成后在下面将显示付款方、收款方的成功打款回单详情图作为打款凭证进行上传。</p>
          <p class="marTop6">收款人名称 {{confirmOrderInfo.debt_receive_bank_owner}}</p>
          <p class="marTop6">收款银行 {{confirmOrderInfo.debt_receive_bank_name}}</p>
          <p class="marTop6">收款账号 {{confirmOrderInfo.debt_receive_bank_no}}</p>

          <div class="uploadBox" :style="uploadBoxStyle">
            <!--upload_title 上传凭证-->
            <van-uploader 
              v-model="fileList"
              multiple
              :max-count="8" 
              :preview-size="img_height"
              @oversize="onOversize"
              @delete="deleteFile1"
              :after-read="afterRead"
              :before-read="beforeRead"
            >
              <div class="box" :style="boxStyle">
                <div class="icon">+</div>
                <div class="title">打款凭证</div>
              </div>
            </van-uploader>
          </div>


        </div>
      </div>

      <div class="info van-clearfix">
        <div class="basic_info">
          <p class="comment">债权人即出借方</p>
          <van-field
            v-model="creditor_phone"
            type="tel"
            label="债权人会员手机号"
            format-trigger="onBlur"
            class="marTop12"
            placeholder="请填写债权人会员手机号"
            :rules="[{ required: true, pattern: /^\d{11}$/, message: '请输入手机号码' }]"
          />
          <van-field
            v-model="value4"
            label="债权人姓名"
            format-trigger="onBlur"
            class="marTop12"
            placeholder="请填写债权人真实姓名"
          />
          <!-- <van-field
            v-model="value5"
            label="打款帐号"
            format-trigger="onBlur"
            class="marTop12"
            placeholder="请输入打款帐号"
            @input="onInput"
          /> -->
          <van-field
            v-model="value6"
            label="解债经纪人代码"
            format-trigger="onBlur"
            class="marTop12"
            placeholder="请输入解债经纪人代码"
          />

          <div class="helpLink" @click="chat">
            <div class="left">没有经纪人代码？</div>
            <div class="right">立即索取</div>
            <img src="../../assets/debtor/right-arrow.png" >
          </div>

        </div>
      </div>
    </div>
    <div class="complete" :style="completeStyle">
      <van-button @click="submit" type="primary" class="operation_btn">提交审核</van-button>
      <div class="complete-empty"></div>
    </div>
    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif"/>
    </div>
  </div>
</template>

<script>
import navBar from "./components/navBar";
import {uploadMixin} from "./mixin"
import Bus from "../../providers/eventBus"
export default {
  name: "solutionDebtInfo",
  data() {
    return {
      value1: "",
      value2: "",
      creditor_phone: "",
      value4: "",
      value5: "",
      value6: "",
      fileList: [],
      fileList1: [],
      fileNameMap: {},
      imgSrc: "",
      confirmOrderInfo:{},
      payment_info: "",
      solutionDebtInfoWarpperStyle: {height: '100%'},
      completeStyle: {bottom: '0'},
      client: 0,
      // 新增upload修改  写死99px
      img_height: '99px',
      loading: false,
      timeId: 0,
      // TODO 目前是写死的
      comments: '金额名词释义：\n解债总金额包含本金和利息（利息可以为0）\n解债总金额（即债务金额）=减免债务金额+需偿还债务金额；\n减免债务金额与需偿还债务金额的比例为65:35；',
    };
  },
  components: {
    navBar,
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    // this.debtorReleaseOrder()
    // this.memberAuthenticate()
    this.confirmOrder()
    // Bus.$on('bussolutionDebtInfo1', this.handleBussolutionDebtInfo)
    this.getAgentCode()
  },
  mounted() {
    this.deductionUA()
    // /3 一行三张
    // 新增upload修改 注释掉自适应
    // this.img_height = ((document.body.clientWidth - 39)/3 - 8 - 1) + 'px'
  },
  computed: {
    reduceDebt(){
      const {value1, value2} = this.filterMoney(this.value1, this.value2)
      return ((value1 + value2)*0.65).toFixed(2)
    },
    needMoney(){
      const {value1, value2} = this.filterMoney(this.value1, this.value2)
      return ((value1 + value2)*0.35).toFixed(2)
    },
    solutionMoney(){
      const {value1, value2} = this.filterMoney(this.value1, this.value2)
      return (value1 + value2).toFixed(2)
    },
    uploadBoxStyle(){
      return { 'height': this.img_height }  
    },
    boxStyle(){
      return { width: this.img_height, height: this.img_height }
    },
  },
  destroyed() {
    clearInterval(this.timeId)
  },
  mixins: [uploadMixin],
  methods: {
    //联系客服
    chat() {
      this.showDialog = false
      this.params('18', '18', 'customerService')
    },
    getAgentCode(){
      this.$api.post("/debt/member/debtor-order/count")
      .then(data => {
        this.value6 = data.agent_code
      })
    },
    afterRead(file){
      this._afterRead(file, 'voucher', this.fileList, this.fileList1, this.fileNameMap)
    },
    deleteFile1(file){
      this.deleteFile(file, this.fileList1, this.fileNameMap)
    },
    onInput(v) {
      if (! v) {
        return
      }
      if (v.length > 20) {
        this.value5 = v.slice(0,20) 
      }
    },
    limitMoney1(value){
      if (parseFloat(value) > 10000000) {
        this.$toast('本金不能超过1000w')
        this.value1 = this.value1.slice(0, -1)
      }
      if (/\.[0-9][0-9]./.test(this.value1)) {
        this.value1 = this.value1.slice(0, -1)
        this.$toast('最多输入两位小数')
      }
    },
    limitMoney2(value){
      if (parseFloat(value) > 10000000) {
        this.$toast('利息不能超过1000w')
        this.value2 = this.value2.slice(0, -1)
      }
      if (/\.[0-9][0-9]./.test(this.value2)) {
        this.value2 = this.value2.slice(0, -1)
        this.$toast('最多输入两位小数')
      }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.client = 11; 
      } else if (/android/.test(ua)) {
        this.client = 10;
      }
    },
    // handleBussolutionDebtInfo(data){
    //   this.value1 = data.value1
    //   this.value2 = data.value2
    //   this.creditor_phone = data.creditor_phone
    //   this.value4 = data.value4
    //   this.value5 = data.value5
    //   this.value6 = data.value6
    //   this.fileList = data.fileList
    //   this.fileList1 = data.fileList1
    //   if (Object.keys(data.confirmOrderInfo).length === 0) {
    //     // 如果传过来的值为空，则去请求
    //     this.confirmOrder()
    //     return
    //   }
    //   this.confirmOrderInfo = data.confirmOrderInfo
    // },
    goBack() {
      this.$router.go(-1);
    },
    filterMoney(value1, value2){
      value1 = value1 ? value1 : 0
      value2 = value2 ? value2 : 0
      return {value1: parseFloat(value1), value2: parseFloat(value2)}
    },
    handleDeleteImg() {
      this.imgSrc = "";
    },
    confirmOrder() {
      this.$api.post('debt/member/debtor-order/confirm').then(data => {
        this.confirmOrderInfo = data
      })
    },
    submit() {
      // 验证
      const verifyList = [
        {
          toast: '请输入本金',
          value: this.value1,
          regexp: /^[0-9]*\.*[0-9]+$/,
          // regexp: /^(([1-9][0-9]*\.[0-9][0-9]*)|([0]\.[0-9][0-9]*)|([1-9][0-9]*)|([0]{1}))$/,
        },
        {
          toast: '请输入利息',
          value: this.value2,
          regexp: /^[0-9]*\.*[0-9]+$/,
        },
        {
          toast: '请填写正确的债权人手机号',
          value: this.creditor_phone,
          regexp: /^1\d{10}$/,
        },
        {
          toast: '请填写债权人真实姓名',
          value: this.value4,
          regexp: /\S+/,
        },
        // {
        //   toast: '请输入打款帐号',
        //   value: this.value5,
        //   regexp:/^[0-9]{1,20}$/,
          
        // },
        {
          toast: '请输入解债经纪人代码',
          value: this.value6,
          regexp: /\S+/,
        },
      ]
      
      for (let i = 0; i < verifyList.length; i++) {
        const obj = verifyList[i]
        if (! obj.regexp.test(obj.value)) {
          this.$toast(obj.toast)
          return
        }
      }
      if (this.fileList.length === 0) {
        this.$toast('请上传打款凭证图片')
        return
      }
      // if (this.fileList.length !== this.fileList1.length) {
      //   this.loading = true
      //   this.$toast('请等待打款凭证图片上传完毕')
      //   return
      // }

      // TODO: 验证债务人和债权人是否为同一人

      this.loading = true

      // const constTimeout = 60
      // let count = 0

      this.timeId = setInterval(() => {
        // count ++
        // if (count >= constTimeout * 1000 / 200) {
        //   this.$toast('提交失败')
        //   clearInterval(timeId)
        //   this.loading = false 
        //   return
        // }

        if (this.fileList.length === this.fileList1.length) {
          clearInterval(this.timeId)
          // this.loading = false
          
          const {value1, value2} = this.filterMoney(this.value1, this.value2)
          // this.fileList = this.fileList.map(item => item.url)
          const params = {
            "phone": this.creditor_phone,   
            "name":  this.value4,           
            "agent_code": this.value6,  
            "amount": value1 ,              
            "interest_amount": value2,    
            // TODO value5所代表的字段(打款帐号)已经没有input框了
            "pay_account": this.value5,
            "images": this.fileList1,   
          }

          this.$api.post('debt/member/debtor/publish-order', params)
          .then(data => {
            this.$router.push({
              path: '/debtRelief/resultCreateDebt',
              query: {
                id: data.id,
                debt_from:'债务'
              }
            })
          })
          .catch(err => {
            console.log(err);
            this.$toast(err.message)
          })
          .finally(() => {
            this.loading = false
          })

        }
      },200)



    },

    // debtorReleaseOrder(){
    //   this.$api.post('debt/member/debtor/publish-order')
    // },

    // TODO 跟产品确认认证相关的跳转及那些状态能够去填写解债信息(暂时不认证)
    // memberAuthenticate(){
    //   this.$api.get('/member/member/member/auth/detail').then(data => {
    //     if(!data){

    //     }
    //   })
    // },
  },

  // beforeDestroy() {
  //   const data = {
  //     value1: this.value1,
  //     value2: this.value2,
  //     creditor_phone: this.creditor_phone,
  //     value4: this.value4,
  //     value5: this.value5,
  //     value6: this.value6,
  //     fileList: this.fileList,
  //     fileList1: this.fileList1,
  //   }
  //   Bus.$emit('bussolutionDebtInfo2', data)

  //   Bus.$off('bussolutionDebtInfo1', this.handleBussolutionDebtInfo)
  // },

};
</script>


<style lang="less">
.solutionDebtInfo-warpper2 {
  overflow-x: hidden;
  // background-color: #fff;
  padding: 88px 0 0;
  box-sizing: border-box;
  // height: 100%;
  color: #333;
  font-size: 16px;
  transition: height 0.1s linear;
  .navbar {
    margin: 24px 5px 0 5px;
  }
  .divider {
    // padding-top: 88px;
    width: 100%;
    height: 12px;
    background-color: #f2f2f2;
  }
  .content {
    padding: 0 12px 98px;
    position: relative;
    // margin: 0 0 83px;
    .comments {
      margin: 12px 0 24px;
      .comment {
        font-size: 12px;
        color: #666666;
        line-height: 19px;
      }
    }
    .title {
      font-size: 15px;
      min-height: 24px;
      line-height: 24px;
    }
    .van-cell {
      // border-bottom: 1px solid #eeeeee;
      &::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
    input::placeholder {
      color: #bababa;
      font-size: 17px;
    }
    .input_money {
      .van-cell__title.van-field__label {
        width: 25px;
        margin-top: 12px;
        margin-left: -16px;
        color: #333;
        font-size: 30px;
      }
      .van-cell__value {
        font-size: 36px;
      }
    }
    .marTop12 {
      margin-top: 12px;
      .van-field__control {
        font-size: 16px;
      }
    }
    .marTop11 {
      margin-top: 11px;
    }
    .marBottom7 {
      margin-bottom: 7px;
    }
    .marBottom3 {
      margin-bottom: 3px;
    }
    .color999 {
      color: #999999;
    }
    .colorOrg {
      color: #fc740c;
    }
    .marTop6 {
      margin-top: 6px;
    }
    .collect_details {
      background-color: #f5f6f7;
      padding: 15px 15px 15px 15px;
      margin-top: 12px;
      .payment_account {
        font-size: 13px;
        color: #999999;
        line-height: 21px;
        min-height: 21px;
        margin-bottom: 15px;
      }
      p {
        // height: 26px;
        line-height: 26px;
      }
    }
    
    .basic_info {
      margin: 9px 0 0 0;
      .comment {
        font-size: 15px;
        color: #999999;
        line-height: 24px;
        margin-top: 21px;
      }
      .van-cell {
        padding: 10px 0;
        &:not(:last-child)::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 16px;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        }
      }
      .van-field__label {
        font-size: 17px;
        color: #333;
        font-weight: bold;
        width: auto;
        margin-right: 15px;
      }
      .helpLink {
        width: fit-content;
        margin: 16px 0 15px;
        display: flex;
        align-items: center;
        .left {
          font-size: 14px;
          color: #999999;
          line-height: 22px;
        }
        .right {
          font-size: 14px;
          color: #666666;
          line-height: 22px;
        }
        img {
          width: 17px;
          height: 15px;
        }
      }
    }
    .uploadBox {
      margin-top: 18px;
      // min-height: 100px;

      // 新增upload修改
      overflow-x: auto;
      overflow-y: hidden;

      .box {
        // width: 100px;
        // height: 100px;
        background-color: #fff;
        border: 1px dashed #dedede;
        box-sizing: border-box;
        .icon {
          text-align: center;
          color: #999999;
          height: 21px;
          line-height: 21px;
          margin: 27px 0 9px;
          font-size: 35px;
        }
        .title {
          text-align: center;
          font-size: 13px;
          height: 21px;
          line-height: 21px;
          color: #555555;
        }
      }

      // 新增upload修改
      .van-uploader__wrapper {
        flex-wrap: nowrap;
      }
      .van-uploader__preview-delete {
        position: absolute;
        top: 0px;
        right: 0px;
        color: #fff;
        font-size: 16px;
        // padding: 3px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 0px 3px 0px 3px;
      }
      .van-icon-clear:before {
        content: "\F042";
      }
      .van-uploader__preview-image {
        border-radius: 3px !important;
      }


    }
  }
  .complete {
    position: fixed;
    // bottom: 0;
    padding: 24px 12px 0;
    // width: calc(100% - 24px);
    box-sizing: border-box;
    width: 100%;
    background-color: #F5F6F7;
    transition: bottom 0.1s linear;
    .complete-empty {
      background-color: #F5F6F7;
      height: 24px;
      width: 100%;
    }
    .operation_btn {
      background-color: #fc740c;
      color: #fff;
      border: none;
      width: 100%;
      margin: 0 auto;
      height: 50px;
      font-size: 17px;
      display: block;
      border-radius: 25px;
      line-height: 50px;
      font-weight: 600;
    }
  }
  .van-uploader__preview-delet {
    font-size: 26px;
  }
  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

}
</style>
